



































































import { Component } from "vue-property-decorator";
import GetRoutes from "@/modules/routes/getRoutes";
import { onLogin } from "@/api/AuthAPI/user-authorized-module";
import { AxiosError } from "axios";

@Component({
  mixins: [GetRoutes],
})
class Login extends GetRoutes {
  form = {
    name: "",
    password: "",
  };
  show = true;
  alert = "";
  showPassword = false;
  send = false;

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    this.send = true;
    onLogin({
      login: this.form.name,
      password: this.form.password,
    })
      .then(async (permitions) => {
        console.log(permitions);
        this.alert = "";
        this.send = false;
        await this.startGetRoutes();
        this.$router.push("/");
      })
      .catch((e: AxiosError) => {
        this.alert = String(e.code);
        this.send = false;
        this.$store.dispatch("onLogout");
        console.log(e);
      });
  }

  onReset(event: HTMLFormElement): void {
    event.preventDefault();
    this.form.name = "";
    this.form.password = "";
    this.show = false;
    this.$nextTick(() => {
      this.show = true;
    });
  }
}
export default Login;
